// node_modules
import { FC, useContext, useEffect } from "react";
import { Redirect, Route, Switch, useParams, useRouteMatch } from "react-router-dom";
// Enums
import { CaseActionTypeEnum } from "Enums";
// Custom hooks
import { useFetch } from "Hooks";
// Interfaces
import { ICaseSelectedAction, ICaseSetCaseIdAction } from "Interfaces";
// Stores
import { CaseContext, AuthContext } from "Stores";
// Types
import { TUseFetch, TCase } from "Types";
// Components
import { AsynchronousWrapper } from "Components";
import { Delivery } from "./Delivery/Delivery";
// styles
import styles from "./case.module.scss";
// Helpers
import { AxiosHelperSingleton } from "Helpers";
// Constants
import { GeneralConstants } from "Constants";

export const Cases: FC = () => {
    // `url` lets
    // us build relative links.
    const { url } = useRouteMatch();

    // We use `useParams` hook here to access
    // the dynamic pieces of the URL (the Case ID).
    const { caseId } = useParams<{ caseId: string | undefined }>();

    // Shared states
    const { caseState, caseDispatch } = useContext(CaseContext);
    const { authState } = useContext(AuthContext);

    // We use `useFetch` custom hook here
    // to fetch data from the server
    const { isLoading, didError, errorMessage, fetchedData }: TUseFetch<TCase> = useFetch(`api/cases/${caseId}`);

    useEffect(() => {
        if (!isLoading && !errorMessage && !didError && caseId && fetchedData) {

            let hasAccess = false;
            if (fetchedData.isDynamicDelivery) {
                if (authState.hasAccessToDynamicDelivery) {
                    hasAccess = true;
                } else if (authState.igorAIEnv.trim().toLowerCase() !== GeneralConstants.IGORAI_SAAS_ENV.trim().toLowerCase() &&
                        fetchedData.isDeliveryRedesign) {
                    hasAccess = true;
                }
            } else if (authState.igorAIEnv.trim().toLowerCase() !== GeneralConstants.IGORAI_SAAS_ENV.trim().toLowerCase() &&
                    fetchedData.isDeliveryRedesign) {
                hasAccess = true;
            }

            if (hasAccess) {
                caseDispatch({ type: CaseActionTypeEnum.SetSelectedCaseInfo, newCaseId: parseInt(caseId, 10) } as ICaseSetCaseIdAction);
                caseDispatch({ type: CaseActionTypeEnum.SetSelectedCase, newSelectedCase: fetchedData } as ICaseSelectedAction);
            } else {
                window.location.replace(`${AxiosHelperSingleton.getServerBaseURL()}Cases/Delivery/${caseId}`);
            }
        }
    }, [caseDispatch, caseId, didError, errorMessage, fetchedData, isLoading, authState.hasAccessToDynamicDelivery, authState.igorAIEnv]);

    return (
        <div className={styles.caseContainer}>
            <AsynchronousWrapper didError={didError} errorMessage={errorMessage} isLoading={isLoading} LoaderComponent={null}>
                {caseState.selectedCaseId && caseState.selectedCase && caseState.isDeliveryRedesign ?
                    <Switch>
                        <Route path={`${url}/delivery`}>
                            <Delivery />
                        </Route>
                        <Route>
                            <Redirect to={`${url}/delivery`} />
                        </Route>
                    </Switch>
                    :
                    <></>

                }
            </AsynchronousWrapper>
        </div>
    );
};